module.exports = __webpack_public_path__ + "static/img/serve8Model.602e3660.png";